import {Injectable} from '@angular/core';
import {BaseService} from '../../../services/base.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RootObject} from '../models/product';
import {User} from '../models/user';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../services/auth.service';
import {Subject} from 'rxjs';
import {ProductService} from './product.service';
import {CustomerAddress} from '../models/CustomerInfo/CustomerAddress';

import {concatMap} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OrderService extends BaseService {


    constructor(private httpClient: HttpClient,
                private authService: AuthService) {
        super();
    }

    getOrders() {
        return this.httpClient.get<any>(this.baseAPI2 + '/mage/orders', this.authService.getHttpOptions());
    }

    getCustomerOrders(type) {

        let serviceURL = this.baseAPI + 'adham/customer/orders';

        let params = {
            'type': type,
        };


        return this.httpClient.post<any>(serviceURL, params, this.authService.getHttpOptions());
    }

    getOrderDetails(OrderID) {

        let serviceURL = this.baseAPI + 'adham/customer/order' + '/' + OrderID;

        return this.httpClient.get<any>(serviceURL, this.authService.getHttpOptions());


    }

    getAdminOrderDetails(orderId) {
        return this.httpClient.get<any>(this.baseAPI2 + '/mage/order/' + orderId, this.authService.getHttpOptions());

    }

    getAramexPackaging(orderId) {
        return this.httpClient.get<any>(this.baseAPI2 + '/aramex/packaging/' + orderId, this.authService.getHttpOptions());

    }

    cancelOrder(id) {

        let serviceURL = 'adham/customer/order/cancel' + '/' + id;
        return this.httpClient.post<any>(serviceURL, this.authService.getHttpOptions());

    }

}
